import PlayerWrapper from 'components/set/InteractionPlayer/PlayerWrapper/PlayerWrapper'
import React from 'react'
import VideoPlayer from 'components/set/InteractionPlayer/VideoPlayer/VideoPlayer'
import { getVideoUrl } from 'utils/mux'
import { Pass } from 'data/Pass'
import { Unpopulated } from 'data/Populated'
import { Show } from 'data/Show'

interface VideoOnDemandProps {
    title: string
    stateId: string
    videoStartTime?: number
    playbackId: string
    passList: Unpopulated<Pass, 'show'>[]
    show: Show
}

const VideoOnDemand: React.FC<VideoOnDemandProps> = ({
    title,
    playbackId,
    videoStartTime,
    stateId,
    passList,
    show,
}) => {
    return (
        <PlayerWrapper stateId={stateId}>
            <VideoPlayer
                type="vod"
                videoTitle={title}
                src={getVideoUrl(playbackId)}
                disablePauseControls={false}
                disableChromecast={false}
                videoEndedCallback={() => {}}
                videoStartTime={videoStartTime}
                show={show}
                passList={passList}
            />
        </PlayerWrapper>
    )
}

export default React.memo(VideoOnDemand)
